"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicLoadBasePluginMethods = void 0;
var DynamicLoadBasePluginMethods;
(function (DynamicLoadBasePluginMethods) {
    DynamicLoadBasePluginMethods["BeforeInitialize"] = "beforeInitialize";
    DynamicLoadBasePluginMethods["AfterInitialize"] = "afterInitialize";
})(DynamicLoadBasePluginMethods || (exports.DynamicLoadBasePluginMethods = DynamicLoadBasePluginMethods = {}));
//# sourceMappingURL=dynamicLoadPlugin.types.js.map